<ng-container [formGroup]="newEditForm">
    <td class="icon"></td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" id="{{'titular' + randomId}}" formControlName="titular">
        <label for="{{'titular' + randomId}}"></label>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" id="{{'ambito' + randomId}}" formControlName="ambito">
        <label for="{{'ambito' + randomId}}"></label>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="estadosProteccion"
            [selectedItem]="newEditForm.get('estado')" [placeHolder]="false" [disabled]="disableEstadosProteccion">
        </app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <div class="calendar inside-td">
            <label></label>
            <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
            <mat-datepicker #fechaInicio></mat-datepicker>
        </div>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <div class="calendar inside-td">
            <label></label>
            <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
            <mat-datepicker #fechaFin></mat-datepicker>
        </div>
    </td>
    
    <td class="multi-actions">
        <ng-container *ngIf="!proteccion || isEditable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf=" proteccion && !isEditable">
            <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" (click)="enableEdit()"></i>
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" (click)="askDelete()"></i>
        </ng-container>
    </td>
</ng-container>

<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="cancelDelete()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>

<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>